export async function extractText(file: File): Promise<string> {
  const extension = file.name.split(".").pop()?.toLowerCase();
  if (["txt", "md", "markdown", "csv", "json"].includes(extension ?? "")) return file.text();
  if (extension === "pdf") {
    const [{ GlobalWorkerOptions, getDocument }, { default: pdfWorker }] = await Promise.all([
      import("pdfjs-dist"),
      import("pdfjs-dist/build/pdf.worker.min.mjs?url"),
    ]);
    GlobalWorkerOptions.workerSrc = pdfWorker;
    const bytes = new Uint8Array(await file.arrayBuffer());
    const document = await getDocument({ data: bytes }).promise;
    const pages: string[] = [];
    for (let pageNumber = 1; pageNumber <= document.numPages; pageNumber += 1) {
      const page = await document.getPage(pageNumber);
      const content = await page.getTextContent();
      pages.push(content.items.map((item) => "str" in item ? item.str : "").join(" "));
    }
    return pages.join("\n\n");
  }
  if (extension === "pptx") {
    const { default: JSZip } = await import("jszip");
    const zip = await JSZip.loadAsync(await file.arrayBuffer());
    const slideFiles = Object.keys(zip.files)
      .filter((name) => /^ppt\/slides\/slide\d+\.xml$/.test(name))
      .sort((a, b) => Number(a.match(/\d+/)?.[0] ?? 0) - Number(b.match(/\d+/)?.[0] ?? 0));
    const slides: string[] = [];
    for (const name of slideFiles) {
      const xml = await zip.files[name].async("string");
      const document = new DOMParser().parseFromString(xml, "application/xml");
      const text = Array.from(document.getElementsByTagName("a:t")).map((node) => node.textContent ?? "").join(" ");
      slides.push(text);
    }
    return slides.join("\n\n");
  }
  throw new Error("不支持的文件格式");
}
